import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Translate } from 'react-localize-redux';
import type { SurgerySurgeonRow } from '../types';

interface SurgerySurgeonTableProps {
  rows: SurgerySurgeonRow[];
  title: string;
}

const SurgerySurgeonTable: React.FC<SurgerySurgeonTableProps> = ({ rows, title }) => (
  <Box>
    <Typography variant="h6">{title}</Typography>
    {rows.length === 0 ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        <Translate id="hospital.analytics.no_data" />
      </Typography>
    ) : (
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Translate id="hospital.analytics.surgery.tables.surgeon" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.episodes" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.completed" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.kpis.planned" /></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.surgeonUuid}>
                <TableCell>{row.surgeonLabel}</TableCell>
                <TableCell align="right">{row.episodeCount}</TableCell>
                <TableCell align="right">{row.completed}</TableCell>
                <TableCell align="right">{row.planned}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);

export default SurgerySurgeonTable;
